module.exports = __webpack_public_path__ + "img/boxIcon.59770f9e.png";